<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>查询条件</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="getSalesInfoManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-date-picker
                  v-model="getSalesInfoManageInfo.conditions.beginTime"
                  type="datetime"
                  placeholder="选择开始时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
          </el-form-item>
          <el-form-item>
            <el-date-picker
                  v-model="getSalesInfoManageInfo.conditions.endTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
          </el-form-item>
          <el-form-item>
            <el-input
                  v-model="getSalesInfoManageInfo.conditions.prodNameLike"
                  placeholder="请输入商品名称"
                  clearable
                  style="width: 100%"
                />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="_queryGetSalesInfoMethod">查询</el-button>
            <el-button icon="el-icon-refresh" @click="_resetGetSalesInfoMethod">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>销售明细</span>
          </div>
          <div class="">
          <el-table
            :data="getSalesInfoManageInfo.getSalesInfos"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="orderId" label="订单号" align="center" />
            <el-table-column prop="cartType" label="类型" align="center">
              <template slot-scope="scope">
                {{ scope.row.cartType == 3306  ? '商品' :  '服务' }}
              </template>
            </el-table-column>
            <el-table-column prop="prodName" label="名称" align="center" />
            <el-table-column prop="cartNum" label="销售数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.cartNum || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="personName" label="用户名称" align="center" />
            <el-table-column prop="payPrice" label="明细金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.payPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="discountPrice" label="商品优惠" align="center">
              <template slot-scope="scope">
                {{ scope.row.discountPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="orderDiscountPrice" label="订单优惠" align="center">
              <template slot-scope="scope">
                {{ scope.row.orderDiscountPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="orderPayPrice" label="订单金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.orderPayPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="returnCartNum" label="退货数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.returnCartNum || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="returnPayPrice" label="退货明细金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.returnPayPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="dReturnPayPrice" label="退货订单金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.dReturnPayPrice || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" />
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="getSalesInfoManageInfo.total"
            style="margin-top: 20px; text-align: right"
          />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getSalesInfoList } from '@/api/goods/getSalesInfoApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'GetSalesInfoManage',
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      getSalesInfoManageInfo: {
        getSalesInfos: [],
        total: 0,
        conditions: {
          beginTime: '',
          endTime: '',
          prodNameLike: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this.getSalesInfoManageInfo.conditions.shopId = getShopId()
    this._listGetSalesInfos(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listGetSalesInfos(val, this.pageSize)
    },
    async _listGetSalesInfos(page, rows) {
      this.loading = true
      try {
        const params = {
          ...this.getSalesInfoManageInfo.conditions,
          page,
          row: rows
        }
        const res = await getSalesInfoList(params)
        this.getSalesInfoManageInfo.getSalesInfos = res.data
        this.getSalesInfoManageInfo.total = res.total
      } catch (error) {
        console.error('获取销售明细失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryGetSalesInfoMethod() {
      this.currentPage = 1
      this._listGetSalesInfos(this.currentPage, this.pageSize)
    },
    _resetGetSalesInfoMethod() {
      this.getSalesInfoManageInfo.conditions = {
        beginTime: '',
        endTime: '',
        prodNameLike: '',
        shopId: getShopId()
      }
      this.currentPage = 1
      this._listGetSalesInfos(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>